<template>
  <component :is="tagEl" v-if="$slots.default">
    <slot v-if="$slots.default"></slot>
  </component>
  <HtmlTitle v-else-if="text" />
</template>

<script setup lang="ts">
import { computed, h } from 'vue';

interface ObjectTitle {
  tag: string;
  text: string;
}

interface Props {
  title?: string | ObjectTitle;
  tag?: string;
}
const props = withDefaults(defineProps<Props>(), {
  title: '',
  tag: '',
});

const tagEl = computed(() => {
  if (
    (props.title as ObjectTitle)?.tag &&
    /^div|span|h[1-6]$/i.test((props.title as ObjectTitle).tag)
  )
    return (props.title as ObjectTitle).tag;

  return props.tag || 'h2';
});

const text = computed(() =>
  typeof props.title === 'string' ? props.title : props.title?.text,
);

const HtmlTitle = () => h(tagEl.value, { innerHTML: text.value });
</script>
